import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

export const containerStyles = css({
  display: 'flex',
  padding: '12px 8px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',

  borderRadius: '8px',
  backgroundColor: 'white',
  boxShadow: '0 0 1px 0 rgba(30, 31, 33, 0.31), 0 1px 1px 0 rgba(30, 31, 33, 0.25)',

  // desktop
  '@media (min-width: 1000px)': {
    padding: '16px 8px',
    boxShadow: '0 0 1px 0 rgba(30, 31, 33, 0.31), 0 8px 12px 0 rgba(30, 31, 33, 0.15)',
    maxWidth: '290px',
  },
});

export const linksContainerStyles = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const linkStyles = css({
  padding: '4px 0 4px 16px',
  position: 'relative',

  '& a': {
    // limit to 2 lines
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': '2',
    wordBreak: 'break-word',

    overflow: 'hidden',
    color: token('color.text.subtle'),
    textOverflow: 'ellipsis',
    textDecoration: 'none',

    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
  },
});

export const activeLinkStyle = css({
  // desktop
  '@media (min-width: 1000px)': {
    backgroundColor: token('color.background.accent.blue.subtlest'),
    borderRadius: '4px',

    '& a': {
      color: token('color.text.brand'),
    },

    ':before': {
      content: '""',
      display: 'block',
      width: '2px',
      height: '16px',
      backgroundColor: token('color.text.brand'),
      position: 'absolute',
      left: '0',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
});

export const titleStyles = css({
  padding: '0 16px',

  '& h6': {
    textOverflow: 'ellipsis',
    fontSize: '16px !important', // override default heading size on mobile
    lineHeight: '24px !important', // override default heading line height on mobile
  },

  // desktop
  '@media (min-width: 1000px)': {
    display: 'none',
  },
});
